export default "__VITE_ASSET__WtfwzY1F__"